import { NamedDefinitionPage } from './NamedDefinitionPage';

export function CustomerSubGroupsPage() {
  return (
    <NamedDefinitionPage
      apiBase="/api/customersubgroups"
      listRoute="/customer-sub-groups"
      title="Müşteri Ek Grubu Yönetimi"
      subtitle="Müşteri ek grubu kayıtlarını filtreleyin, sıralayın ve yönetin."
      codeLabel="Ek Grup Kodu"
      descriptionLabel="Açıklama"
      newLabel="Yeni Müşteri Ek Grubu"
    />
  );
}
